var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#003842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8573 -15.5184C94.8573 -15.5184 68.4787 -2.95593 73.1606 28.1212C78.4135 62.967 47.9525 77.9223 27.1408 69.308C6.32912 60.6639 7.78508 28.6895 -31.7828 27.7024C-72.2071 26.7154 -80.7145 -13.5443 -80.7145 -13.5443",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3677 -24.8806C64.3677 -24.8806 52.9484 1.68004 57.0308 28.0911C61.1417 54.5021 42.671 57.6128 35.3341 54.5021C20.0894 48.1013 17.1489 13.8237 -7.45971 11.6103C-25.959 9.93536 -50.8531 23.1857 -64.0424 -6.87439",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0634 -13.0358C52.0634 -13.0358 56.1744 14.0931 37.9891 9.24758C17.1489 3.68422 17.4629 -9.35679 -8.91564 2.96636C-18.308 7.36322 -56.1059 8.64937 -48.4835 -15.5184",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8742 45.1403C43.2416 45.1403 46.782 39.6766 46.782 32.9368C46.782 26.197 43.2416 20.7333 38.8742 20.7333C34.5068 20.7333 30.9663 26.197 30.9663 32.9368C30.9663 39.6766 34.5068 45.1403 38.8742 45.1403Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 39.2466C37.3674 39.2466 39.2864 37.3276 39.2864 34.9603C39.2864 32.5931 37.3674 30.6741 35.0002 30.6741C32.6329 30.6741 30.7139 32.5931 30.7139 34.9603C30.7139 37.3276 32.6329 39.2466 35.0002 39.2466Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0003 26.2454C40.7552 26.2454 46.1013 27.0712 50.1323 28.4589C54.989 30.131 57.9752 32.6654 57.9752 34.9603C57.9752 37.3518 54.8105 40.0442 49.595 41.7723C45.6519 43.0786 40.4631 43.7606 35.0003 43.7606C29.3993 43.7606 24.0956 43.1205 20.1081 41.7579C15.0632 40.0336 12.0246 37.3062 12.0246 34.9603C12.0246 32.684 14.8757 30.1692 19.6642 28.4997C23.7102 27.0891 29.1884 26.2454 34.9995 26.2454H35.0003Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4137 30.628C30.2888 25.6428 33.6747 21.4241 36.8907 18.6254C40.7654 15.2534 44.4527 13.9329 46.4407 15.0792C48.5124 16.2739 49.2638 20.3606 48.1552 25.7418C47.3179 29.8103 45.3157 34.6457 42.5866 39.378C39.7884 44.23 36.5844 48.5047 33.4123 51.2774C29.3983 54.7863 25.5176 56.0561 23.4854 54.8841C21.5135 53.7477 20.7594 50.0208 21.7054 45.0386C22.5047 40.8289 24.5105 35.662 27.4128 30.6279L27.4137 30.628Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4209 39.3907C24.5377 34.4111 22.5747 29.3697 21.7553 25.1859C20.769 20.1449 21.4664 16.2907 23.4525 15.1411C25.5222 13.9428 29.438 15.3328 33.5464 18.9807C36.6527 21.7387 39.8423 25.8874 42.5794 30.6154C45.3856 35.4626 47.4888 40.3735 48.3069 44.5064C49.3422 49.7364 48.5043 53.7325 46.474 54.9078C44.504 56.0483 40.899 54.8408 37.0551 51.5329C33.8073 48.7382 30.3325 44.4198 27.4209 39.3906V39.3907Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.6cb39962c9d37941adb97a9d9d569384.svg";
export { ForwardRef as ReactComponent };